import axios from "axios";
import _ from "lodash";
import { saveAs } from "file-saver";

import i18n from "@/i18n"
import {
  CalcularPrecioCantidadesExactas,
  CalcularTecnica
} from "@/api/reprocesos";
import {
  GetCart,
  AddToCart,
  DeleteLineFromCart,
  DeleteCart,
  PrintIncompleteReproceso,
  FinishCart,
  CallAcaExtranet,
  PrintAllCart,
  PrintAllBocetosCart
} from "@/api/extranet";

/**
 * Procesa errores de stock y lanza la alerta correspondiente mapeando los reprocesos afectados
 */
const _handleStockError = (dispatch, rootGetters, errorData, confirmPayload) => {
  let actualCart = rootGetters["carrito/actualCart"];

  // Si el payload contiene una lista específica de IDs a confirmar, filtramos el carrito
  if (confirmPayload?.reprocesosIds && Array.isArray(confirmPayload.reprocesosIds)) {
    actualCart = actualCart.filter(r => confirmPayload.reprocesosIds.includes(r.id));
  }

  // Procesar todos los errores de stock del array ListError
  const listProducts = errorData.ListError.map(error => {
    const productCode = error.ProductCode;
    const stockLimit = error.StockAvailable;

    // Encontrar reprocesos que pertenecen a la selección y contienen este producto
    const affectedReprocesos = actualCart.filter(reproceso =>
      reproceso.productos?.some(p => (p.reference || p.Reference) === productCode)
    );

    const reprocesosIds = affectedReprocesos.map(r => r.id);

    // Sumar cantidades totales solicitadas de ese producto en todo el carrito
    let totalQuantity = 0;
    affectedReprocesos.forEach(reproceso => {
      const matchingProducts = reproceso.productos.filter(
        p => (p.reference || p.Reference) === productCode
      );
      matchingProducts.forEach(p => {
        totalQuantity += p.quantity || p.Quantity || 0;
      });
    });

    return {
      productCode: productCode,
      quantity: totalQuantity,
      stockLimit: stockLimit,
      reprocesosIds: reprocesosIds
    };
  });

  dispatch(
    "modelo/addAlert",
    {
      code: "WarningProductNoStock",
      listProducts: listProducts
    },
    { root: true }
  );
};

export default {
  addLoadingCarrito({ commit }) {
    commit("ADD_LOADING");
  },
  removeLoadingCarrito({ commit }) {
    commit("REMOVE_LOADING");
  },

  deleteReproceso({ commit, state, dispatch }, payload) {
    commit("ADD_LOADING");
    commit("DELETE_REPROCESO", payload);
    if (state.sobrecosteCantidadExacta > 0)
      dispatch("CalcularCantidadExacta");
    commit("REMOVE_LOADING");
  },

  deleteReprocesoById({ commit, state, dispatch }, payload) {
    commit("ADD_LOADING");
    commit("DELETE_REPROCESO_BY_ID", payload);
    if (state.sobrecosteCantidadExacta > 0)
      dispatch("CalcularCantidadExacta");
    commit("REMOVE_LOADING");
  },

  restoreCarrito({ commit }, payload) {
    commit("ADD_LOADING");
    commit("RESTORE_CARRITO", payload);
    commit("REMOVE_LOADING");
  },

  async setColor({ commit }, payload) {
    commit("ADD_LOADING");
    commit("SET_COLOR", payload);
    commit("REMOVE_LOADING");
  },

  async updateNumeroReprocesos({ commit }, payload) {
    commit("ADD_LOADING");
    commit("UPDATE_N_REPROCESOS", payload);
    commit("REMOVE_LOADING");
  },
  async REMOVENumeroReprocesos({ commit }, payload) {
    commit("ADD_LOADING");
    commit("REMOVE_N_REPROCESOS", payload);
    commit("REMOVE_LOADING");
  },
  borrarManipulados({ commit }, payload) {
    commit("ADD_LOADING");
    commit("BORRAR_MANIPULADOS", payload);
    commit("REMOVE_LOADING");
  },

  async calcularPrecios(
    { commit, dispatch, state, rootGetters },
    parametros,
  ) {
    commit("ADD_LOADING");
    return new Promise((resolve, reject) => {
      parametros.divisa = rootGetters["modelo/currency"];
      parametros.language = rootGetters["config/actualLanguageRegion"];


      const actualTecnica = rootGetters["config/getTecnicaMapExtraParam"](parametros.tecnica)

      // Comprobación de que no tenga ningún color en el carrito baneado para alguna técnica
      let bannedColors = rootGetters["modelo/getBannedColorListByZoneAndTecnicas"](parametros.posicion, actualTecnica);

      if (bannedColors.length > 0) {
        let productoConColorBaneado = state.carrito.productos.find(producto => bannedColors.includes(producto.color));

        if (productoConColorBaneado) {
          dispatch(
            "modelo/addAlert",
            {
              code: "errorColorBanned",
              product: `${i18n.t("COLORS." + productoConColorBaneado.color)} (${productoConColorBaneado.color})`,
            },
            { root: true }
          );

          // Añadimos un reproceso "falso", para que lo detecte como error al no tener precios, y no deje continuar a menos que se modifique
          commit("ADD_REPROCESO", {
            reproceso: {
              prices: {
                articulos: null
              },
              tecnica: parametros.tecnica,
              lineas: [],
              total: 0,
              modelo: parametros.codigo,
              id: parametros.id,
              zona: parametros.zona,
              params: parametros,
              isRepeticion: parametros.isRepeticion,
            },
            warningTech: []
          });

          if (state.sobrecosteCantidadExacta > 0)
            dispatch("CalcularCantidadExacta");

          console.warn("Color baneado en la técnica", bannedColors, parametros?.posicion);
          commit("REMOVE_LOADING");
          reject("errorColorBanned");
          return;
        }
      }

      const { warningTech: _warningTech, ...paramsWithoutWarning } = parametros;
      const warningTech = _warningTech || [];
      CalcularTecnica({
        payload: paramsWithoutWarning,
        key: rootGetters["config/isYouReprocesos"] ? rootGetters["config/youReprocesosSession"] : rootGetters["config/key"]
      })
        .then(response => {
          let reproceso = {
            prices: response.data,
            params: parametros
          };

          if (response.data.articulos.length == 0) {
            dispatch(
              "modelo/addAlert",
              {
                code: "errorResponseEmpty"
              },
              { root: true }
            );
          }

          commit("ADD_REPROCESO", { reproceso, warningTech });

          if (state.sobrecosteCantidadExacta > 0)
            dispatch("CalcularCantidadExacta");
          resolve(response);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });

  },

  // Obsoleta
  async calcularPreciosTransferEspeciales(
    { commit, dispatch, state, rootGetters },
    parametros
  ) {
    commit("ADD_LOADING");
    let parametros2 = {
      codigoModelo: parametros.codigoModelo,
      calidad: parametros.calidad,
      colores: parametros.colores,
      prendas: parametros.prendas,
      idTamano: parametros.idTamano,
      antimigracion: parametros.antimigracion,
      ignifugo: parametros.ignifugo,
      feston: parametros.feston,
      esRepeticion: parametros.esRepeticion,
      precioProveedor: parametros.precioProveedor,
      divisa: rootGetters["modelo/currency"],
      language: rootGetters["config/actualLanguageRegion"]
    };
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.VUE_APP_WEB_MARCADO}/Reprocesos/getSAPTransferEspeciales`,
          {
            params: parametros2
          }
        )
        .then(response => {
          let reproceso = {
            tecnica: parametros.tecnica,
            zona: parametros.zona.Zona,
            modelo: parametros.codigoModelo,
            productos: [],
            lineas: [],
            atributos: null,
            data: response.data,
            sap: response.data.sap,
            info: response.data.info,
            total: 0,
            params: {
              ...parametros,
              type: "TransferEspeciales"
            }
          };

          commit("ADD_REPROCESO", { reproceso, warningTech: [] });
          if (state.sobrecosteCantidadExacta > 0)
            dispatch("CalcularCantidadExacta");
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },

  async fetchComercialCart({ commit, rootGetters }) {
    if (!rootGetters["config/loggedClient"]) return;
    commit("ADD_LOADING");
    return new Promise((resolve, reject) => {
      GetCart({
        comercialToken: rootGetters["config/comercialToken"],
        reprocesosKey: rootGetters["config/key"],
        type: "COMERCIAL"
      })
        .then(response => {
          commit("SET_COMERCIAL_CART", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },

  async fetchClientCart({ commit, rootGetters }) {
    commit("ADD_LOADING");
    return new Promise((resolve, reject) => {
      GetCart({
        reprocesosKey: rootGetters["config/key"],
        type: "CLIENT"
      })
        .then(response => {
          commit("SET_CLIENT_CART", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },

  async addToClientCart({ commit }, pedido) {
    commit("ADD_LOADING");

    let orderBody = new FormData();
    orderBody.append("NewDesignDataForm", pedido.body.NewDesignDataForm);
    orderBody.append("OrderForm", JSON.stringify(pedido.body.order));
    if (pedido.BocetosRepetidos) {
      pedido.BocetosRepetidos.forEach(boceto => {
        orderBody.append(`Bocetos[${boceto.id}]`, boceto.value);
      });
    }
    return new Promise((resolve, reject) => {
      AddToCart({
        type: "CLIENT",
        payload: orderBody,
        reprocesosKey: pedido.key
      })
        .then(response => {
          commit("CONFIRM_CARRITO", pedido);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },

  async deleteLineClientCart({ commit, rootGetters }, reprocesoId) {
    commit("ADD_LOADING");
    return new Promise((resolve, reject) => {
      DeleteLineFromCart({
        lineId: reprocesoId,
        reprocesosKey: rootGetters["config/key"],
        type: "CLIENT"
      })
        .then(response => {
          commit("SET_CLIENT_CART", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },

  async deleteCompleteClientCart({ commit, rootGetters }) {
    commit("ADD_LOADING");
    return new Promise((resolve, reject) => {
      DeleteCart({
        reprocesosKey: rootGetters["config/key"],
        type: "CLIENT"
      })
        .then(response => {
          commit("SET_CLIENT_CART", []);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },

  async confirmClientCart({ commit, rootGetters }, payload) {
    commit("ADD_LOADING");
    return new Promise((resolve, reject) => {
      FinishCart({
        reprocesosKey: rootGetters["config/key"],
        payload,
        type: "CLIENT"
      })
        .then(response => {
          commit("SET_LAST_CART", rootGetters["carrito/clientCart"]);
          commit("SET_CLIENT_CART", []);
          commit("SET_FINISH_CART", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },



  async confirmComercialCart({ commit, rootGetters }, payload) {
    commit("ADD_LOADING");
    return new Promise((resolve, reject) => {
      FinishCart({
        reprocesosKey: rootGetters["config/key"],
        comercialToken: rootGetters["config/comercialToken"],
        payload,
        type: "COMERCIAL"
      })
        .then(response => {
          commit(
            "SET_LAST_CART",
            rootGetters["carrito/comercialCart"]
          );
          commit("SET_COMERCIAL_CART", []);
          commit("SET_FINISH_CART", response.data);

          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },

  async callAcaExtranet({ commit, rootGetters }, payload) {
    commit("ADD_LOADING");
    return new Promise((resolve, reject) => {
      CallAcaExtranet({
        reprocesosKey: rootGetters["config/key"],
        comercialToken: rootGetters["config/comercialToken"],
        payload,
        type: rootGetters["config/comercialToken"] ? "COMERCIAL" : "CLIENT"
      })
        .then(response => {
          resolve(response?.data);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },

  async deleteLineComercialCart({ commit, rootGetters }, reprocesoId) {
    commit("ADD_LOADING");
    return new Promise((resolve, reject) => {
      DeleteLineFromCart({
        lineId: reprocesoId,
        reprocesosKey: rootGetters["config/key"],
        comercialToken: rootGetters["config/comercialToken"],
        type: "COMERCIAL"
      })
        .then(response => {
          commit("SET_COMERCIAL_CART", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },

  async deleteCompleteComercialCart({ commit, rootGetters }) {
    commit("ADD_LOADING");
    return new Promise((resolve, reject) => {
      DeleteCart({
        comercialToken: rootGetters["config/comercialToken"],
        reprocesosKey: rootGetters["config/key"],
        type: "COMERCIAL"
      })
        .then(response => {
          commit("SET_COMERCIAL_CART", []);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },



  async addProducto({ commit }, payload) {
    commit("ADD_LOADING");
    commit("ADD_PRODUCTO", payload);
    commit("UPDATE_TOTALES");
    commit("REMOVE_LOADING");
  },
  async deleteProducto({ commit }, producto) {
    commit("ADD_LOADING");
    commit("DELETE_PRODUCTO", producto);
    commit("UPDATE_TOTALES");
    commit("REMOVE_LOADING");
  },
  async deleteAllProducts({ commit, state }) {
    commit("ADD_LOADING");
    state.carrito.productos.forEach(producto => {
      commit("DELETE_PRODUCTO", producto);
    });
    commit("UPDATE_TOTALES");
    commit("REMOVE_LOADING");
  },

  async confirmPedido({ commit, rootGetters, dispatch }, pedido) {
    // Añadimos los bocetos anteriores, en caso de que tengamos alguna coincidencia de id
    let bocetosRepetidos = rootGetters["design/bocetosRepeticion"];
    if (bocetosRepetidos.length > 0) {
      pedido.BocetosRepetidos = bocetosRepetidos;
    }

    // Si estamos en una sesión de cliente
    if (
      rootGetters["config/clientCartAvalible"] &&
      !(
        rootGetters["config/comercialInfo"] &&
        rootGetters["config/comercialToken"]
      )
    )
      return dispatch("addToClientCart", pedido);

    let orderBody = new FormData();
    orderBody.append("NewDesignDataForm", pedido.body.NewDesignDataForm);
    orderBody.append("OrderForm", JSON.stringify(pedido.body.order));
    if (pedido.body.YouReprocesosInfo)
      orderBody.append("YouReprocesosInfoForm", JSON.stringify(pedido.body.YouReprocesosInfo));
    if (pedido.BocetosRepetidos) {
      pedido.BocetosRepetidos.forEach(boceto => {
        orderBody.append(`Bocetos[${boceto.id}]`, boceto.value);
      });
    }

    commit("ADD_LOADING");
    return new Promise((resolve, reject) => {
      AddToCart({
        type:
          rootGetters["config/comercialToken"] &&
            rootGetters["config/comercialInfo"]
            ? "COMERCIAL"
            : rootGetters["config/isYouReprocesos"]
              ? "YOUREPROCESOS"
              : "CLIENT",
        payload: orderBody,
        reprocesosKey: rootGetters["config/isYouReprocesos"] ? rootGetters["config/youReprocesosSession"] : pedido.key,
        comercialToken: rootGetters["config/comercialToken"]
      })
        .then(response => {
          commit("CONFIRM_CARRITO", pedido);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },

  async uploadImage({ commit }, imagen) {
    commit("ADD_LOADING");
    const formData = new FormData();
    formData.append("imagenB64", imagen.imagen);
    formData.append("key", imagen.key);
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${process.env.VUE_APP_WEB_MARCADO}/Reprocesos/uploadDesign`,
          formData,
          {
            headers: {
              "Content-Type": "text/xml"
            }
          }
        )
        .then(response => {
          commit;
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },

  async dowloadAllBocetosInCart({ commit, rootGetters }, payload) {
    commit("ADD_LOADING");

    return new Promise((resolve, reject) => {
      PrintAllBocetosCart({
        type:
          rootGetters["config/comercialToken"] &&
            rootGetters["config/comercialInfo"]
            ? "COMERCIAL"
            : rootGetters["config/isYouReprocesos"]
              ? "YOUREPROCESOS"
              : "CLIENT",
        reprocesosKey: rootGetters["config/isYouReprocesos"] ? rootGetters["config/youReprocesosSession"] : rootGetters["config/key"],
        lang: rootGetters["config/actualLanguageRegion"],
        comercialToken: rootGetters["config/comercialToken"],
        payload
      }).then(response => {
        const iso = new Date().toISOString();
        let formattedDate =
          iso.slice(2, 10).replace(/-/g, "") +
          "_" +
          iso.slice(11, 16).replace(/:/g, "");
        const fileName = `Reprocresos_bocetos_cart_${formattedDate}.pdf`;
        saveAs(response.data, fileName);
        // commit("CONFIRM_PRESUPUESTO", pedido);
        resolve(response);
      })
        .catch(error => {
          reject(error);
          return false;
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },

  async dowloadAllPresupuestosInCart({ commit, rootGetters }, payload) {
    commit("ADD_LOADING");

    return new Promise((resolve, reject) => {
      PrintAllCart({
        type:
          rootGetters["config/comercialToken"] &&
            rootGetters["config/comercialInfo"]
            ? "COMERCIAL"
            : rootGetters["config/isYouReprocesos"]
              ? "YOUREPROCESOS"
              : "CLIENT",
        reprocesosKey: rootGetters["config/isYouReprocesos"] ? rootGetters["config/youReprocesosSession"] : rootGetters["config/key"],
        lang: rootGetters["config/actualLanguageRegion"],
        comercialToken: rootGetters["config/comercialToken"],
        payload
      }).then(response => {
        const iso = new Date().toISOString();
        let formattedDate =
          iso.slice(2, 10).replace(/-/g, "") +
          "_" +
          iso.slice(11, 16).replace(/:/g, "");
        const fileName = `Reprocesos_cart_${formattedDate}.pdf`;
        saveAs(response.data, fileName);
        // commit("CONFIRM_PRESUPUESTO", pedido);
        resolve(response);
      })
        .catch(error => {
          reject(error);
          return false;
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },

  async presupuesto({ commit, rootGetters }, pedido) {
    commit("ADD_LOADING");
    return new Promise((resolve, reject) => {
      PrintIncompleteReproceso({
        payload: pedido,
        reprocesosKey: rootGetters["config/isYouReprocesos"] ? rootGetters["config/youReprocesosSession"] : rootGetters["config/key"],
        lang: rootGetters["config/actualLanguageRegion"]
      })
        .then(response => {
          const iso = new Date().toISOString();
          let formattedDate =
            iso.slice(2, 10).replace(/-/g, "") +
            "_" +
            iso.slice(11, 16).replace(/:/g, "");
          const fileName = `Reproceso_${formattedDate}.pdf`;
          saveAs(response.data, fileName);
          // commit("CONFIRM_PRESUPUESTO", pedido);
          resolve(response);
        })
        .catch(error => {
          reject(error);
          return false;
        })
        .finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },

  async CalcularCantidadExacta({ commit, state, rootGetters }) {
    console.log("CCE");
    let listReprocesos = state.carrito.reprocesos
      .filter(r => !r.isExtraCantidadExacta)
      .map(r => r.params);


    return new Promise((resolve, reject) => {
      commit("ADD_LOADING");
      if (!_.isEqual(listReprocesos, state.listReprocesos)) {
        commit("REMOVE_CANTIDADEXACTA");

        CalcularPrecioCantidadesExactas({
          payload: { listReprocesos },
          divisa: rootGetters["modelo/currency"],
          isProveedor: rootGetters["config/isProveedor"],
          key: rootGetters["config/isYouReprocesos"] ? rootGetters["config/youReprocesosSession"] : rootGetters["config/key"],
          language: rootGetters["config/actualLanguageRegion"]
        }).then(response => {
          // response.data.tecnica = "CantidadExacta";
          let reproceso = {
            prices: response.data,
            params: {
              tecnica: "Cantidad Exacta",
              atributos: JSON.stringify({ listReprocesos })
            },
            isExtraCantidadExacta: true,
            tecnica: "CantidadExacta"
          };
          console.log("🚀 ~ reproceso:", reproceso)

          commit("ADD_REPROCESO", { reproceso, warningTech: [] });

          resolve();
        })
          .catch((e) => {
            reject("Ha ocurrido una excepción al calcular las cantidades exactas", e)
          })
          .finally(() => {
            commit("REMOVE_LOADING");
          });
      }
    })
  },

  async EliminarCantidadExacta({ commit }) {
    console.log("ECE");

    commit("ADD_LOADING");
    return new Promise((resolve, reject) => {
      try {
        commit("REMOVE_CANTIDADEXACTA");
        resolve(true);
      } catch (error) {
        reject(error);
        return false;
      }
    }).finally(() => {
      commit("REMOVE_LOADING");
    });
  },

  // Función para decidir entre dos funciones que ejecutar
  async useCorrectCartFunctionAsync(
    { commit, rootGetters, dispatch },
    payload
  ) {
    // Distintos dispatch a ejecutar
    const dispatchClient = payload.dispatchClient;
    const dispatchComercial = payload.dispatchComercial;

    // Distintos payloads a enviar
    const payloadClient = payload.payloadClient || payload.genericPayload || {};
    // console.log("🚀 ~ payloadClient:", payloadClient)
    const payloadComercial = payload.payloadComercial || payload.genericPayload || {};
    // console.log("🚀 ~ payloadComercial:", payloadComercial)

    let errorMessage = "Error al procesar la solicitud";
    commit("ADD_LOADING");
    return new Promise((resolve, reject) => {
      if (rootGetters["config/activeClient"]) {

        if (!dispatchClient) {
          commit("REMOVE_LOADING");
          reject(errorMessage + " Función de cliente no definida");
        }

        dispatch(dispatchClient, payloadClient)
          .then(resolve)
          .catch(reject)
          .finally(() => {
            commit("REMOVE_LOADING");
          });
      } else if (rootGetters["config/activeComercial"]) {

        if (!dispatchComercial) {
          commit("REMOVE_LOADING");
          reject(errorMessage + " Función de comercial no definida");
        }

        dispatch(dispatchComercial, payloadComercial)
          .then(resolve)
          .catch(reject)
          .finally(() => {
            commit("REMOVE_LOADING");
          });
      } else {
        commit("REMOVE_LOADING");
        reject(errorMessage + " No activo comercial ni cliente");
      }
    });
  },

  async fetchActualCart({ dispatch }) {
    return dispatch("useCorrectCartFunctionAsync", {
      dispatchClient: "fetchClientCart",
      dispatchComercial: "fetchComercialCart",
    });
  },

  async deleteActualCart({ dispatch }) {
    return dispatch("useCorrectCartFunctionAsync", {
      dispatchClient: "deleteCompleteClientCart",
      dispatchComercial: "deleteCompleteComercialCart",
    });
  },

  async confirmActualCart({ dispatch, rootGetters }, payload) {
    return dispatch("useCorrectCartFunctionAsync", {
      dispatchClient: "confirmClientCart",
      dispatchComercial: "confirmComercialCart",
      genericPayload: payload,
    }).catch(error => {
      const errorData = error.response?.data;
      if (errorData?.IdError === "ProductNoStock") {
        _handleStockError(dispatch, rootGetters, errorData, payload);
      }
      throw error;
    });
  },

  // No la usamos ya que no hace una validación real
  async validateAddress({ commit, rootGetters }, address) {
    commit("ADD_LOADING");
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.VUE_APP_EXTRANET_URL}/Client/Address/Validate`, address, { headers: { ReprocesosKey: rootGetters['config/key'] } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },

  async fetchAddress({ commit, rootGetters }) {
    commit("ADD_LOADING");
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.VUE_APP_EXTRANET_URL}/Client/Address/Shipping`, {
          params: {
            Size: 0
          },
          headers: {
            ReprocesosKey: rootGetters['config/key']
          },
        })
        .then((response) => {
          commit("SET_ADDRESS", response.data?.list ?? []);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(() => {
          commit("REMOVE_LOADING");
        });
    });
  },

  async addInfoTecnicaActualZone({ commit }, payload) {
    commit("ADD_LOADING");
    commit("UPDATE_INFO_TECNICA_ACTUAL_ZONE", payload)
    commit("REMOVE_LOADING");
  }
};
